const PSEUDO_USER_ROLE = 'Read Only Pseudo Login Merchant Dashboard';
const ADMIN_USER_ROLE = 'MerchantAdminUserRole';

export const getUserScopes = (product_accounts = [], mid) => {
    if(product_accounts.length < 1) return [];
    let loggedInUserScopes = product_accounts.filter((account) => mid == account.identifier)[0]?.scopes || null;
    let isPseudoUser = product_accounts[0]?.acl_role?.name == PSEUDO_USER_ROLE;

    return loggedInUserScopes || (isPseudoUser ? product_accounts[0]?.scopes : []);
}

export const isAdminUser = (product_accounts = [], mid) => {
    let isAdminUser = product_accounts.filter((account) => mid == account.identifier)[0]?.acl_role?.name === ADMIN_USER_ROLE;

    return isAdminUser;
}